import { render, staticRenderFns } from "./UserDetailMainInfoTile.vue?vue&type=template&id=7312b281&scoped=true&lang=pug&"
import script from "./UserDetailMainInfoTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailMainInfoTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailMainInfoTile.vue?vue&type=style&index=0&id=7312b281&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312b281",
  null
  
)

export default component.exports